// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");
var MultipleSelectOptions$ReactHooksTemplate = require("./MultipleSelectOptions.res.js");

function MultipleSelectPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var multipleSelect = props.multipleSelect;
  var match = React.useState(function (param) {
        
      });
  var setErrorMessage = match[1];
  var errorMessage = match[0];
  var onTitleChange = function (html) {
    Curry._1(onChange, MultipleSelect$ReactHooksTemplate.setText(multipleSelect, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, MultipleSelect$ReactHooksTemplate.setDescription(multipleSelect, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: MultipleSelect$ReactHooksTemplate.getTextTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: MultipleSelect$ReactHooksTemplate.getDescriptionTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Choices",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.map(MultipleSelect$ReactHooksTemplate.nonEmptyChoices(multipleSelect), (function (choice) {
                                          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                      children: Caml_option.some(JsxRuntime.jsx(MultipleSelectOptions$ReactHooksTemplate.make, {
                                                                choice: choice,
                                                                multipleSelect: multipleSelect,
                                                                onChange: onChange,
                                                                language: language,
                                                                setErrorMessage: setErrorMessage,
                                                                textInputClassName: " h-48-px py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full ",
                                                                checkBoxInputClassName: " mb-2 ",
                                                                checkboxClassName: " custom_checkbox ",
                                                                containerClassName: " text-sm font-normal "
                                                              }))
                                                    });
                                        })))
                            })
                      ],
                      className: "flex flex-col"
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                errorMessage !== undefined ? JsxRuntime.jsx("div", {
                        children: errorMessage,
                        className: "text-red-500 text-sm mt-1 text-left"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = MultipleSelectPreview;

exports.make = make;
/* react Not a pure module */
